export default __webpack_public_path__ + "static/media/marathon.40719f3d.jpg";